import { FilterCategoryField } from '../../../store/product-center.store.model';

export enum ChipCategory {
  PRODUCT_RANGE = 1,
  ASSET_CLASS = 2,
  GEOGRAPHICAL_EXPOSURE = 3,
  DISTRIBUTION_FREQUENCY = 4,
}

export type Chip = {
  categoryField: FilterCategoryField;
  chipId: number;
  label: string;
};
